import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAdmin"]),
    ...mapGetters("httpResponse", ["httpText", "httpColor", "httpIsActive"]),
    ...mapGetters("processLoader", ["isProcessingActive"]),
    ...mapGetters("service", [
      "status",
      "available",
      "details",
      "serviceAccount",
      "ipGroups",
      "serviceDetails",
      `rateplans`
    ]),
    ...mapGetters("logs", ["auditLogs", "authLogs"]),
    ...mapGetters("cancellationHistory", ["cancellationHistoryList"]),
    ...mapGetters("usageReport", ["usage"]),
    ...mapGetters("search", ["services"]),
    ...mapGetters("impersonate", ["wholesalers", "impersonating"]),
    ...mapGetters("wholesalers", [
      "activeWholesalers",
      "wholesalersToUpdate",
      "hasWholesalerToUpdate"
    ]),
    ...mapGetters("featureFlag", ["allFlags"])
  },
  methods: {
    ...mapActions("auth", ["setRoles"]),
    ...mapActions("httpResponse", ["setHttpResponse", "resetHttpResponse"]),
    ...mapActions("processLoader", ["setProcessActive", "setProcessInactive"]),
    ...mapActions("service", [
      "setAvailableService",
      "resetAvailableService",
      "getService",
      "updateService",
      "getServiceAccount",
      "getNbnServices",
      "getStatus",
      "removeService",
      "suspendService",
      "resumeService",
      "reactivateService",
      "requestIPRange",
      "getMasterServices",
      "getGroupList",
      "createEmptyService",
      "requestIP",
      "removeIP",
      "getRadiusAccounts",
      "getGroupListForAccount",
      `getRatePlans`,
      `setRadiusAccount`,
      "uploadFile",
      "checkRadiusUsername",
      "getIpAddresses",
      "importIpAddressesRange",
      "addSingleIpAddresses",
      "releaseIpAddres",
      "updateIpAddressState",
      "addVispAccount",
      "switchProtocol"
    ]),
    ...mapActions("logs", ["getAuditLogs", "getAuthLogs"]),
    ...mapActions("cancellationHistory", ["getCancellationHistory"]),
    ...mapActions("search", ["select", "search"]),
    ...mapActions("impersonate", [
      "getWholesalers",
      "setImpersonatingAs",
      "removeImpersonating",
      "getImpersonating"
    ]),
    ...mapActions("wholesalers", [
      "getActiveWholesalers",
      "setWholesalersForUpdate",
      "removeWholesalerForUpdate",
      "updateWholesalerDetails",
      "updateActiveWholesalers",
      "createWholesalerLogin",
      "readWholesalerLogins",
      "updateWholesalerLogin",
      "deleteWholesalerLogin",
      "updateWholesalerCc"
    ]),
    saveService(payload) {
      let vm = this;

      // Remove ALL whitespace (leading, trailing, middle)
      if (payload.service.radiusUsername) {
        payload.service.radiusUsername =
          payload.service.radiusUsername.replace(/\s+/g, '');
      }

      vm.updateService(payload).then(() => {
        vm.isEditable = false;
        vm.getNbnServices({ showDeleted: vm.showDeleted })
          .then(() => {
            vm.isEditable = false;
          })
          .catch(() => {});
      });
    },
    viewAsTable() {
      this.getWholesalers();
      this.$refs.viewTable.toggleDisplay = true;
    },
    clearDomain() {
      this.resetImpersonation();
      this.$store.dispatch("domain/clear");
      this.$auth.logout({ returnTo: window.location.origin });
    }
  }
};
